// Статусы клиентов по давности последнего депозита (запрос №22, 2026-10-30).
//
// Источник истины — база трекера депозитов в админ-панели: gateway
// периодически тянет оттуда «telegramId → дата последнего депозита» и
// раздаёт вкладкам. Сам статус НЕ хранится: это чистая функция от даты
// депозита, текущего времени и настроек порогов, поэтому он «обновляется
// сам» без кронов — SPA пересчитывает его раз в минуту.
//
// Интервалы непрерывные, по верхней границе: Горячий — до hot.maxHours,
// Тёплый — до warm.maxHours и т. д.; последний (Маринад) открыт сверху.
// Отключённый статус = клиенты этого окна остаются без бейджа и не
// попадают в фильтры (соседние окна не расширяются).
export const CLIENT_DEPOSIT_STATUS_IDS = [
    "hot",
    "warm",
    "cold",
    "sleeping",
    "marinade"
];
export const DEFAULT_CLIENT_STATUS_SETTINGS = {
    enabled: true,
    statuses: [
        { id: "hot", enabled: true, maxHours: 24 },
        { id: "warm", enabled: true, maxHours: 3 * 24 },
        { id: "cold", enabled: true, maxHours: 7 * 24 },
        { id: "sleeping", enabled: true, maxHours: 90 * 24 },
        { id: "marinade", enabled: true, maxHours: null }
    ]
};
export const CLIENT_STATUS_MAX_HOURS = 24 * 365 * 10;
const isStatusId = (value) => typeof value === "string" && CLIENT_DEPOSIT_STATUS_IDS.includes(value);
/**
 * Нормализация настроек из любого источника (БД, тело PUT): всегда ровно
 * пять правил в каноническом порядке, границы — целые часы, строго
 * возрастающие; у последнего правила границы нет. Невалидное значение
 * границы заменяется дефолтом, а не ломает весь объект.
 */
export const sanitizeClientStatusSettings = (raw) => {
    const source = (raw && typeof raw === "object" ? raw : {});
    const byId = new Map();
    if (Array.isArray(source.statuses)) {
        for (const entry of source.statuses) {
            if (entry && typeof entry === "object" && isStatusId(entry.id)) {
                byId.set(entry.id, entry);
            }
        }
    }
    let previousMax = 0;
    const statuses = DEFAULT_CLIENT_STATUS_SETTINGS.statuses.map((fallback) => {
        const entry = byId.get(fallback.id);
        const enabled = entry ? entry.enabled !== false : fallback.enabled;
        if (fallback.maxHours === null) {
            return { id: fallback.id, enabled, maxHours: null };
        }
        const requested = entry ? Number(entry.maxHours) : fallback.maxHours;
        let maxHours = Number.isFinite(requested) && requested > 0
            ? Math.min(CLIENT_STATUS_MAX_HOURS, Math.floor(requested))
            : fallback.maxHours;
        if (maxHours <= previousMax) {
            maxHours = previousMax + 1;
        }
        previousMax = maxHours;
        return { id: fallback.id, enabled, maxHours };
    });
    return {
        enabled: source.enabled === undefined ? DEFAULT_CLIENT_STATUS_SETTINGS.enabled : source.enabled === true,
        statuses
    };
};
/**
 * Статус клиента на момент `now` (ms) по дате последнего депозита.
 * null — депозита нет, дата невалидна, статусы выключены или окно, в
 * которое попал клиент, отключено админом.
 */
export const resolveClientDepositStatus = (lastDepositAt, settings, now) => {
    if (!settings.enabled || !lastDepositAt) {
        return null;
    }
    const depositedAt = Date.parse(lastDepositAt);
    if (!Number.isFinite(depositedAt)) {
        return null;
    }
    // Депозит «из будущего» (дата вручную выставлена вперёд или часы
    // разъехались) считаем свежим.
    const ageHours = Math.max(0, now - depositedAt) / 3_600_000;
    for (const rule of settings.statuses) {
        if (rule.maxHours === null || ageHours < rule.maxHours) {
            return rule.enabled ? rule.id : null;
        }
    }
    return null;
};
//# sourceMappingURL=client-status.js.map